import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TokenService } from '@services/auth/token.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { commonDtOptions, theads } from './table.definition';
import { TitleService } from '@services/title.service';

@Component({
  selector: 'app-customer-request',
  templateUrl: './customer-request.component.html',
  styleUrls: ['./customer-request.component.scss'],
})
export class CustomerRequestComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public dtOptions: any = {};
  public tableData: object[] = [];
  public theads = theads;

  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private titleService: TitleService
  ) {
    this.titleService.updateTitle('Contacts');

    this.dtOptions = {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        const baseParams = {
          limit: dataTablesParameters.length,
          page: dataTablesParameters.start / dataTablesParameters.length + 1,
        };

        this.http
          .get(environment.newInventoryApi + 'customer/queries/list', {
            headers: this.tokenService.getTokenHeader(),
            params: baseParams,
          })

          .subscribe((resp) => {
            this.tableData = this.prepareTableData(resp['data']);

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  ngOnInit(): void {}

  ngAfterViewChecked() {
    // This is for to fix the style for show entries
    const parentElement = document.getElementById('customer-requests_length');

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });

        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  prepareTableData(queries: object[]) {
    const preparedData = queries?.map((query, index) => {
      return {
        'SL No': index + 1,
        Customer: `${query?.['first_name']} ${query?.['last_name']}`,
        Date: query?.['created_at']?.slice(0, 10) || '--',
        'Phone No': query?.['phone_number'] || '--',
        Subject: query?.['subject'] || '--',
        Message: query?.['message'] || '--',
      };
    });

    return preparedData;
  }
}
